export type CourierLocation = {
  userId: string;
  name: string;
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string | null;
  city: number | null;
  /** null — координаты в Redis протухли (TTL 5 минут), курьер не выходит на связь. */
  latitude: number | null;
  longitude: number | null;
  updatedAt: string | null;
  shiftOpen: string;
};

/** Курьер, у которого точно есть координаты — сужение для отрисовки на карте. */
export type LocatedCourier = CourierLocation & {
  latitude: number;
  longitude: number;
};

export const hasLocation = (
  courier: CourierLocation,
): courier is LocatedCourier =>
  courier.latitude !== null && courier.longitude !== null;

export const courierName = (courier: CourierLocation) =>
  [courier.lastName, courier.firstName].filter(Boolean).join(" ") ||
  courier.name ||
  courier.phoneNumber ||
  courier.userId;
